import { z } from 'zod';

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
const positiveMoney = z
  .string()
  .regex(/^\d+(\.\d{1,4})?$/, 'must be a money value')
  .refine((v) => Number(v) > 0, 'must be greater than zero');

export const createIntercompanyTransactionInputSchema = z
  .object({
    /** The company funding/paying (its cash is credited; it books a receivable). */
    fromCompanyId: z.string().uuid(),
    /** The company receiving the benefit (it books a payable). */
    toCompanyId: z.string().uuid(),
    date: isoDate,
    amount: positiveMoney,
    description: z.string().max(500).nullable().optional(),
    /** Account credited in the FROM company (usually its bank/cash). */
    fromAccountId: z.string().uuid(),
    /** Account debited in the TO company (an expense for a reimbursement, or cash for a loan). */
    toAccountId: z.string().uuid(),
  })
  .refine((d) => d.fromCompanyId !== d.toCompanyId, {
    message: 'The two companies must be different.',
    path: ['toCompanyId'],
  });
export type CreateIntercompanyTransactionInput = z.infer<typeof createIntercompanyTransactionInputSchema>;

export interface IntercompanyTransaction {
  id: string;
  fromCompanyId: string;
  fromCompanyName: string;
  toCompanyId: string;
  toCompanyName: string;
  date: string;
  amount: string;
  description: string | null;
  fromJournalEntryId: string;
  toJournalEntryId: string;
  status: 'active' | 'voided';
  createdAt: string;
}
